<template>
  <div>
    <div class="sign-up-title text-center mb-4">
      Create your {{ AppName }} individual profile
    </div>
    <b-button :disabled="submitting" variant="outline-secondary" class="w-100" @click="onGoogleSubmit">
      <google-icon /> Sign up with Google
    </b-button>
    <b-row class="align-items-center mt-4 mb-3">
      <b-col><div class="think-line" /></b-col>
      <b-col cols="auto">OR</b-col>
      <b-col><div class="think-line" /></b-col>
    </b-row>
    <identity-form :submitting="submitting" :state="state" :verify-key="verifyKey" @submit="onUserSignUp" />
  </div>
</template>

<script>
import { googleSignUpUserUrl } from '@/helpers/external'
import GoogleIcon from '@/assets/images/google.svg'
import { AppName } from '@/helpers/constants'
import IdentityForm from '@/components/forms/CreateProfile/IdentityForm.vue'

export default {
  name: 'Identity',

  props: {
    verifyKey: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      AppName,
      state: {},
      submitting: false
    }
  },

  methods: {
    onGoogleSubmit() {
      location.href = googleSignUpUserUrl(this.verifyKey)
    },

    onUserSignUp(data) {
      this.submitting = true
      this.$store.dispatch('signup/teamMemberSignUp', data)
        .then(() => this.$emit('submitted'))
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    }
  },

  components: {
    IdentityForm,
    GoogleIcon
  }
}
</script>
